import { useSelector } from "react-redux";
import { getQuestionStats } from "../../../utils/questionStats";
import "./QuestionLegend.css";

export default function QuestionLegend() {
  const { questionsData } = useSelector((state) => state.examSlice);

  const counts = getQuestionStats(questionsData);

  return (
    <>
      <div className="legend-title">Overview</div>

      <div className="legend-container">
        <div className="legend-item">
          <span className="legend-icon not-visited">{counts.notVisited}</span>
          <span>Not Visited</span>
        </div>

        <div className="legend-item">
          <span className="legend-icon marked">{counts.marked}</span>
          <span>Marked for Review</span>
        </div>

        <div className="legend-item">
          <span className="legend-icon answered">{counts.answered}</span>
          <span>Answered</span>
        </div>

        <div className="legend-item">
          <span className="legend-icon answered-marked">
            {counts.answeredMarked}
          </span>
          <span>Answered & Marked for Review</span>
        </div>

        <div className="legend-item">
          <span className="legend-icon not-answered">{counts.notAnswered}</span>
          <span>Not Answered</span>
        </div>

        <div className="legend-item">
          <span className="legend-icon current">{counts.current}</span>
          <span>Current Question</span>
        </div>
      </div>
    </>
  );
}
